<div class="view-content">
  <div class="deployed-devices">
    @for (device of deployedDevices; track device.id) {
      <div class="deployed-device" [ngClass]="{'active': device.id === activeDevice}">
        <div class="name">{{device.name}}</div>
        <div class="status-icons">
          @if (isAutomaticallyInUse[device.id]) {
            <fa-icon icon="cogs" size="lg" pTooltip="Device in-use by an automation!" tooltipPosition="top" aria-hidden="true"></fa-icon>
          }
          @if (isAccessedByDifferentUser[device.id]) {
            <fa-icon icon="user-circle" size="lg" [pTooltip]="getAccessUsers(device)" tooltipPosition="top" aria-hidden="true"></fa-icon>
          }
        </div>
        <button pButton type="button" class="p-button-text access" icon="true" [disabled]="!isConsoleAccessible(device)" [pTooltip]="generateConsoleAccessTooltip(device)" tooltipPosition="top" (click)="accessConsole(device)" [attr.data-testing-id]="'workbench-device-' + device.id + '-console-btn'"><fa-icon [icon]="faDesktop"></fa-icon></button>
        <button pButton type="button" class="p-button-text delete" icon="true" (click)="deleteDevice(device.id)" [attr.data-testing-id]="'workbench-device-' + device.id + '-delete-btn'"><fa-icon [icon]="faTrash"></fa-icon></button>
      </div>
    }
    @if ((deployedDevices || []).length === 0) {
      <div class="empty"><fa-icon [icon]="faInfoCircle" [fixedWidth]="true"></fa-icon> No devices deployed</div>
    }
  </div>

  <div class="wm-m-favorites">
    @if (favorites.length > 0) {
      <div class="favorites">Favorite Devices</div>
      <div class="wm-m-favorites-list">
        @for (fav of favorites; track fav.id) {
          <div class="favorite-wrapper">
            <div class="wm-m-favorite-item"
                 [class.is-disabled]="!isAvailable(fav.id)"
                 [class.active-device]="fav.id === activeFavoriteId"
                 (click)="deployDevice(fav.id)"
                 [pTooltip]="isAvailable(fav.id) ? 'Deploy ' + fav.name : (fav.name + ' (not available)')"
                 tooltipPosition="bottom">

              <img class="favorite-logo"
                   [src]="fav.logo | async"
                   alt="{{ fav.name }}" />

              <div *ngIf="isAvailable(fav.id)" class="hover-overlay">
                <fa-icon [icon]="faUpload"></fa-icon>
              </div>

              <div *ngIf="!isAvailable(fav.id)" class="overlay">
                <fa-icon [icon]="faBan"></fa-icon>
              </div>

            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="deploy-button">
    <button pButton (click)="openDeviceDeploymentTool()">Deploy Device</button>
  </div>
</div>
